// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"d7841730","453":"15cb4c86"}[chunkId] + ".chunk.js";
};